<script setup lang="ts">
import {
	Select,
	SelectContent,
	SelectGroup,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from '@laam/ui/base';
import { PhCalendarBlank } from '@phosphor-icons/vue';
import { SORT_PERIODS } from './utils';

const { $eventClient } = useNuxtApp();

const props = defineProps<{
	entity: string;
	period: string;
}>();

const emit = defineEmits<{
	(event: 'update:period', value: string): void;
}>();

const handleChange = (value: string) => {
	emit('update:period', value);
	$eventClient.sendEvent('select-period-new-arrivals', {
		period: value,
		entity: props.entity,
	});
};
</script>
<template>
	<Select
		class="w-fit"
		:default-value="period"
		@update:model-value="handleChange"
	>
		<SelectTrigger size="sm" class="gap-sm [&_svg]:fill-gray-700">
			<PhCalendarBlank class="size-5xl" />
			<SelectValue class="text-left text-sm font-medium text-gray-700" />
		</SelectTrigger>
		<SelectContent class="max-w-[300px] lg:max-w-full">
			<SelectGroup>
				<SelectItem
					v-for="(label, key) in SORT_PERIODS"
					:key="key"
					:value="key"
					class="[&_svg]:fill-gray-700 cursor-pointer"
				>
					{{ label }}
				</SelectItem>
			</SelectGroup>
		</SelectContent>
	</Select>
</template>
